import cms from '../../../apis/cms';
import {
  OrdenacaoArquivos,
  PaginaDeArquivos,
  ResumoDeMidia,
  SituacaoArquivo,
} from '../models';

// O tenant vai no header x-tenant-id que o cms.rest já envia em toda requisição, e o token de
// login no Authorization (exigido pela api também nas leituras de diagnóstico).

export const buscarResumo = async (): Promise<ResumoDeMidia> => {
  const { data } = await cms.rest.get<ResumoDeMidia>('/diagnostico/midia', {
    params: { limite: 1 },
  });
  return data;
};

export const listarArquivos = async (filtro: {
  situacao: SituacaoArquivo;
  pagina: number;
  porPagina: number;
  ordenarPor: OrdenacaoArquivos;
}): Promise<PaginaDeArquivos> => {
  const { data } = await cms.rest.get<PaginaDeArquivos>(
    '/diagnostico/midia/arquivos',
    { params: filtro },
  );
  return data;
};

export const apagarArquivo = async (id: string): Promise<void> => {
  await cms.rest.delete(`/upload/${id}`);
};

export const apagarNaoUsados = async (
  ids: string[],
): Promise<{ apagados: number }> => {
  const { data } = await cms.rest.post<{ apagados: number }>(
    '/diagnostico/midia/arquivos/apagar',
    { ids },
  );
  return data;
};
